export default "__VITE_ASSET__57034ed8__"